import React, { useState, useEffect, useLayoutEffect, useRef, useCallback } from "react";
import { createPortal } from "react-dom";
import style from "./Dashboard.module.css";
import { IoPlay } from "react-icons/io5";
import welcomeImage from "../../assests/Group 34.png";
import { FaArrowRightLong } from "react-icons/fa6";
import ActiveCalendar from "../../assests/activeCalendar.png";
import ActiveWorkOut from "../../assests/ActiveWeightlifting-sport-exercise-gym (1).png";
import Calendar from "../../assests/Calendar.png";
import WorkOut from "../../assests/Weightlifting-sport-exercise-gym.png";
import Chart from "chart.js/auto";
import { useNavigate, useLocation, useOutletContext } from "react-router-dom";
import { baseurl } from "../Url";
import Loader from "../Loder/Loader";
import TimerImage from "../../assests/Chronometer.png";
import { AiOutlineClose, AiFillCheckCircle, AiFillCloseCircle } from "react-icons/ai";
import { useSelector } from 'react-redux';
import NotificationICon from "../../assests/26. Notification.png";
import Profile from "../../assests/Profile-PNG-File.png";
import { MdWarning, MdPerson, MdFlag } from "react-icons/md";
import CareerPathFlag from "./CareerPathFlag";
import GoalsPopup from "../GoalsPopup/GoalsPopup";
import { logActivity } from "../../services/activityService";
import { ROLE_003, ROLE_005, isMentor } from "../../constants/roles";
import { LuBook, LuUsers } from "react-icons/lu";
import { MdSupport, MdOutlineEvent } from "react-icons/md";
import { MdMoreVert } from "react-icons/md";

const Dashboard = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const outletContext = useOutletContext() || {};
  const { setProfileCompleted: setProfileCompletedContext, setGoalCompleted: setGoalCompletedContext } = outletContext;
  const onMenuToggle = outletContext?.onMenuToggle;
  const sidebarOpen = outletContext?.sidebarOpen;

  const roleId = localStorage.getItem("roleId") || (localStorage.getItem("mentor") === "true" ? ROLE_003 : null);
  const showMentorDashboard = isMentor(roleId) || localStorage.getItem("mentor") === "true";
  const showPatnerDashboard =
    roleId === ROLE_005 ||
    localStorage.getItem("role") === "patner" ||
    localStorage.getItem("authPortal") === "patner";

  const UserName = localStorage.getItem("username")
  const key = JSON.parse(localStorage.getItem("access-token"));
  const UserID = localStorage.getItem("USERID");
  const OrgID = localStorage.getItem("ORGID");

  const chartContainer = useRef(null);
  const chartInstance = useRef(null);
  const careerProgressChartRef = useRef(null);
  const careerProgressChartInstance = useRef(null);
  const careerPathStepsRef = useRef(null);
  const mobileProfileIconRef = useRef(null);
  const mobileGoalsIconRef = useRef(null);
  const sidebarProfileIconRef = useRef(null);
  const sidebarGoalsIconRef = useRef(null);
  const completionTooltipPanelRef = useRef(null);
  const mobileCompletionCloseTimerRef = useRef(null);

  /** Portaled tooltips escape Layout .content / .pageContent overflow-x:hidden (mobile + sidebar) */
  const [completionTooltipSource, setCompletionTooltipSource] = useState(null);
  const [completionTooltipKind, setCompletionTooltipKind] = useState(null);
  const [mobileCompletionCoords, setMobileCompletionCoords] = useState(null);

  const { userDetails, status: userStatus, error: userError } = useSelector((state) => state.user);

  const [learningData, setLearningData] = useState({});
  const [loading, setLoading] = useState(true);
  const [dailYDrill, setDailyDrill] = useState(false);
  const [weeklyWorkout, setWeeklyWorkout] = useState(false);
  const [snoozePopup, setSnoozePopup] = useState(false)
  const [result, setResult] = useState({})
  const [activePopup, setActivePopup] = useState(null);
  const [videoPopup, setVideoPopup] = useState(false)
  const [reminders, setReminders] = useState([]);
  const [events, setEvents] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [careerScore, setCareerScore] = useState(null);
  const [careerPath, setCareerPath] = useState([]);
  const [careerPathLoading, setCareerPathLoading] = useState(true);
  const [bannerList, setBannerList] = useState([]);
  const [experienceCount, setExperienceCount] = useState(0);
  const [skillCount, setSkillCount] = useState(0);
  const [opportunitiesCount, setOpportunitiesCount] = useState(0);
  const [offersCount, setOffersCount] = useState(0);
  const [offersReceivedCount, setOffersReceivedCount] = useState(0);
  const [careerProgressData, setCareerProgressData] = useState({
    innerProgressPercentage: 0,
    outerProgressPercentage: 0,
    totalScore: 0,
    visitedLectures: 0,
    totalLectures: 0,
    completedItems: 0,
    totalItems: 0
  });

  // Completion cards: desktop in right sidebar; mobile in career row (≤1024px), two columns.
  const [profileCompleted, setProfileCompleted] = useState(null);
  const [goalCompleted, setGoalCompleted] = useState(null);
  const [showGoalsPopup, setShowGoalsPopup] = useState(false);
  const [refreshing, setRefreshing] = useState(false);
  const [mentorDashboardData, setMentorDashboardData] = useState(null);
  const careerPathRef = useRef([]);

  const mentorNotifications = [
    { title: "New learner joined", text: "Sarah has been assigned to you. Check Support to connect.", time: "2 hours ago" },
    { title: "Session reminder", text: "You have a session with Alex in 30 minutes.", time: "Just now" },
    { title: "Progress update", text: "3 learners completed their weekly goals this week.", time: "1 day ago" },
  ];

  const totalModules = learningData.Topics ? learningData.Topics.length : 0;
  const totalTopics = learningData.Topics
    ? learningData.Topics.reduce((acc, module) => acc + module.topics.length, 0)
    : 0;
  const totalSkills = learningData.Topics
    ? learningData.Topics.reduce((acc, module) => acc + module.topics.length, 0)
    : 0;
  const completionPercentage = learningData.percentage_completion ? learningData.percentage_completion : 1;

  const getCurrentDate = () => {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const currentDate = getCurrentDate();

  const handleSnooze = (minutes) => {
    if (activePopup === 'dailyDrill') {
      snoozeCreate(minutes, "daily");
    } else if (activePopup === 'weeklyWorkout') {
      snoozeCreate(minutes, "weekly");
    }

  };

  const getUserFirstName = () => {
    const name = userStatus === 'succeeded' && userDetails?.Username
      ? userDetails.Username
      : UserName || 'there';
    // Get first name only (split by space and take first part)
    return name.split(' ')[0];
  };

  const greetingDisplayName =
    userStatus === "succeeded" && userDetails?.Username ? userDetails.Username : UserName || "";
  const greetingName = greetingDisplayName || "there";
  const greetingHeadline = `Hi ${greetingName}, Good day`;

  const defaultWelcomeSlide = {
    title: `Hello ${getUserFirstName()}`,
    subtitle: '',
    description: '',
    image: null,
    link: null,
  };

  const welcomeSlides = bannerList.length > 0
    ? bannerList.map(banner => ({
      title: banner.title || '',
      subtitle: banner.type || '',
      description: banner.description || '',
      image: banner.link || welcomeImage,
      link: banner.link || null,
      route: banner.route || banner.view_link || banner.redirect_to || null,
    }))
    : [defaultWelcomeSlide];

  const [welcomeIndex, setWelcomeIndex] = useState(0);

  useEffect(() => {
    careerPathRef.current = Array.isArray(careerPath) ? careerPath : [];
  }, [careerPath]);

  const nextWelcome = () => {
    setWelcomeIndex((prev) => (prev + 1) % welcomeSlides.length);
  };

  const prevWelcome = () => {
    setWelcomeIndex((prev) => (prev - 1 + welcomeSlides.length) % welcomeSlides.length);
  };

  const handleBannerClick = (link) => {
    if (link) {
      logActivity({ module: "DASHBOARD", action: "BANNER_CLICK", instance: link, remark: "Banner clicked" });
      if (link.startsWith('http://') || link.startsWith('https://')) {
        window.open(link, '_blank');
      } else {
        navigate(link);
      }
    }
  };

  const handleViewButtonClick = (currentSlide) => {
    logActivity({ module: "DASHBOARD", action: "VIEW_BUTTON_CLICK", instance: currentSlide?.title, remark: "Welcome slide view clicked" });
    const route = currentSlide?.route;
    if (route && typeof route === 'string' && !route.startsWith('http')) {
      navigate(route.startsWith('/') ? route : `/${route}`);
      return;
    }

    const title = (currentSlide?.title || '').toLowerCase().trim();
    const type = (currentSlide?.subtitle || '').toLowerCase().trim();
    const text = `${title} ${type}`.trim();

    if (text.includes('skill') || text.includes('competency')) {
      navigate('/learnings');
    } else if (text.includes('opportunity') || text.includes('career')) {
      navigate('/opportunities');
    } else if (text.includes('profile') || text.includes('portfolio')) {
      navigate('/profile');
    } else {
      navigate('/profile');
    }
  };

  const handleSuggestionClick = async (suggestion) => {
    logActivity({ module: "DASHBOARD", action: "RECOMMENDATION_CLICK", instance: suggestion.id || suggestion.title, remark: suggestion.category || "" });
    // Explicit route from API
    const route = suggestion.route;
    if (route && typeof route === 'string' && !route.startsWith('http')) {
      navigate(route.startsWith('/') ? route : `/${route}`);
      return;
    }

    // Opportunity: navigate to job detail if we have vacancy id, else opportunities list
    const category = (suggestion.category || '').toLowerCase();
    const text = `${(suggestion.title || '')} ${(suggestion.description || '')}`.toLowerCase();

    if (category === 'opportunity' || text.includes('opportunity') || text.includes('job')) {
      if (suggestion.vacancyId) {
        navigate(`/job-view/${suggestion.vacancyId}`);
      } else {
        navigate('/opportunities');
      }
      return;
    }

    if (category === 'skill' || text.includes('skill') || text.includes('competency')) {
      const learningId = suggestion.learningId || suggestion.vacancyId;
      if (learningId && UserID) {
        try {
          const res = await fetch(`${baseurl}/userlearning/details/individual`, {
            method: "POST",
            headers: { "Content-Type": "application/json", Authorization: `Bearer ${key}` },
            body: JSON.stringify({ user_id: UserID, userlearning_id: learningId }),
          });
          const data = await res.json();
          if (data?.status && data?.data?.length > 0) {
            const learningDetail = data.data[0];
            localStorage.setItem("newLearningId", learningId);
            navigate("/lerning/detail", {
              state: { learning_detail: learningDetail },
            });
            return;
          }
        } catch (err) {
          console.error("Error fetching learning details:", err);
        }
      }
      navigate('/new/learnings');
      return;
    }

    if (category === 'profile' || text.includes('profile') || text.includes('portfolio')) {
      navigate('/profile');
      return;
    }

    if (category === 'goals' || text.includes('goal')) {
      logActivity({ module: "DASHBOARD", action: "GOALS_POPUP_OPEN", remark: "Goals popup opened from recommendation" });
      setShowGoalsPopup(true);
      return;
    }

    if (category === 'project' || category === 'certification' || category === 'interview') {
      navigate('/profile');
      return;
    }

    navigate('/profile');
  };



  async function learningList() {
    try {
      const res = await fetch(`${baseurl}/userlearning/details`, {
        method: "POST",
        body: JSON.stringify({ user_id: UserID }),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${key}`,
        },
      });
      const data = await res.json();
      console.log(data);
      if (data.status === true) {
        setLearningData(data.data[0] || {});
        localStorage.setItem("categoryID", data.data[0]?.Topics?.[0]?.category_id || "");
      }
    } catch (err) {
      console.error("Error fetching learning details:", err);
    } finally {
      setTimeout(() => setLoading(false), 1000);
    }
  }

  async function dailyWeeklyExam(Type) {
    const type = Type ? Type : "daily"
    await fetch(`${baseurl}/check/daily/weakly/exams`, {
      method: "POST",
      body: JSON.stringify({
        org_id: OrgID,
        user_id: UserID,
        date: currentDate,
        type: type,
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${key}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === true) {
          setResult(data.data[0])

          if (Type && Type === "daily" && data.data[0]?.Daily_Drill?.DailyDrill === true && data.data[0]?.Daily_Drill?.snoozed === false) {
            setDailyDrill(true)
          }
          if (Type && Type === "weekly" && data.data[0]?.WeeklyDrill?.WeeklyDrill === true && data.data[0]?.WeeklyDrill?.snoozed === false) {
            setWeeklyWorkout(true)
          }


          // if (data.data[0]?.Daily_Drill?.DailyDrill === true && data.data[0]?.Daily_Drill?.snoozed === false &&!JSON.parse(localStorage.getItem('hasShownDailyDrill'))) {
          //   setDailyDrill(true);
          //   localStorage.setItem('hasShownDailyDrill',true);
          // }

          if (data.data[0]?.Daily_Drill?.DailyDrill === true && data.data[0]?.Daily_Drill?.snoozed === false && JSON.parse(localStorage.getItem('dailySnoozeTriggered'))) {
            setDailyDrill(true);
            localStorage.removeItem('dailySnoozeTriggered');
          }


          if (data.data[0]?.WeeklyDrill?.WeeklyDrill === true && data.data[0]?.WeeklyDrill?.snoozed === false && JSON.parse(localStorage.getItem('weeklySnoozeTriggered'))) {
            setWeeklyWorkout(true);
            localStorage.removeItem('weeklySnoozeTriggered');


          }
        }
      });
  }

  async function snoozeCreate(min, type) {
    await fetch(`${baseurl}/snooze/create`, {
      method: "POST",
      body: JSON.stringify({
        org_id: OrgID,
        user_id: UserID,
        snooze_min: min.toString(),
        exam_type: type,
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${key}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if (data.status === true) {
          setSnoozePopup(false);
          setActivePopup(null);
          dailyWeeklyExam();
          if (type === "daily") {
            localStorage.setItem('dailySnoozeTriggered', true);
          } else if (type === "weekly") {
            localStorage.setItem('weeklySnoozeTriggered', true);
          }
        }
      });
  }

  const fetchReminders = async () => {
    try {
      if (!UserID) {
        console.log("No UserID, skipping reminders fetch");
        return;
      }

      const mentor = localStorage.getItem("mentor");
      const response = await fetch(`${baseurl}/calendaritem/get`, {
        method: "POST",
        body: JSON.stringify({
          user_id: UserID,
          is_mentor: mentor,
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${key}`,
        },
      });

      const data = await response.json();
      console.log("Reminders API response:", data);

      const ok = data.status === true || data.status === "true";
      if (ok && data.data && Array.isArray(data.data)) {
        console.log("Total reminders received:", data.data.length);

        const parseDateSafe = (value) => {
          try {
            if (value && typeof value === "object" && value.$date) {
              const d = new Date(value.$date);
              return Number.isNaN(d.getTime()) ? null : d;
            }
            const d = new Date(value);
            return Number.isNaN(d.getTime()) ? null : d;
          } catch {
            return null;
          }
        };

        // Show created calendar tasks in To Dos reliably (avoid strict time-window pruning).
        const normalizedReminders = data.data
          .filter((item) => {
            // Check if item has required fields
            if (!item.Title) return false;
            const status = String(item.Status || "").toLowerCase();
            if (status === "completed" || status === "done") return false;
            const now = new Date();
            const startDate = parseDateSafe(item.StartDateTime);
            const endDate = parseDateSafe(item.EndDateTime);
            // Upcoming = not finished yet: prefer end time; if only start, treat as point-in-time upcoming.
            if (endDate) return endDate >= now;
            if (startDate) return startDate >= now;
            return false;
          })
          .sort((a, b) => {
            const createdA = parseDateSafe(a.created_date);
            const createdB = parseDateSafe(b.created_date);
            if (createdA && createdB) return createdB - createdA;
            const dateA = parseDateSafe(a.StartDateTime) || new Date(0);
            const dateB = parseDateSafe(b.StartDateTime) || new Date(0);
            return dateB - dateA;
          })
          .slice(0, 5);

        console.log("To Dos after filtering:", normalizedReminders);
        setReminders(normalizedReminders);
      } else {
        console.log("No reminders data or invalid response structure");
        setReminders([]);
      }
    } catch (error) {
      console.error("Error fetching reminders:", error);
      setReminders([]);
    }
  };

  const fetchEvents = async () => {
    try {
      if (!UserID || !OrgID) {
        setEvents([]);
        return;
      }
      const response = await fetch(`${baseurl}/events/list`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ user_id: UserID, org_id: OrgID }),
      });
      const data = await response.json();
      if (data.status === true && data.events && Array.isArray(data.events)) {
        const now = new Date();

        const parseDate = (value) => {
          if (!value) return null;
          try {
            // Handle Mongo-style {$date: "..."} or plain ISO/string dates
            if (value && typeof value === "object" && value.$date) {
              const d = new Date(value.$date);
              return isNaN(d.getTime()) ? null : d;
            }
            const d = new Date(value);
            return isNaN(d.getTime()) ? null : d;
          } catch {
            return null;
          }
        };

        const apiEventsOnly = data.events.filter((event) => {
          const hasEventIdentity = Boolean(event?.event_id);
          const isCalendarTaskLike =
            String(event?.ItemType || "").toLowerCase() === "task" ||
            (Boolean(event?.CalendarItemID) && !hasEventIdentity);
          return hasEventIdentity && !isCalendarTaskLike;
        });

        const sortedEvents = apiEventsOnly
          .map((event) => {
            // Support both shapes: candidate_profile API (start_date, end_date) and legacy (StartDateTime, EndDateTime)
            const end = parseDate(event.end_date ?? event.EndDateTime);
            const start = parseDate(event.start_date ?? event.StartDateTime);

            // Parse recommended_date (e.g. "2024-01-15 00:00:00" or more verbose strings)
            let recommended = null;
            if (event.recommended_date) {
              const parts = String(event.recommended_date).split(" at ");
              recommended = parseDate(parts[0] || event.recommended_date);
            }

            // Upcoming dashboard events must respect the actual event schedule first.
            const filterDate = end || start || recommended;
            const sortDate = start || end || recommended;

            // For display: if API sent start_date/end_date but no recommended_date, show start_date as recommended_date
            const forDisplay = { ...event };
            if (!forDisplay.recommended_date && (forDisplay.start_date || forDisplay.end_date)) {
              forDisplay.recommended_date = forDisplay.start_date || forDisplay.end_date || "";
            }

            return {
              ...forDisplay,
              _filterDate: filterDate,
              _sortDate: sortDate,
            };
          })
          .filter((event) => {
            if (!event._filterDate) return false;
            return event._filterDate >= now;
          })
          .sort((a, b) => {
            const aDate = a._sortDate || new Date(8640000000000000);
            const bDate = b._sortDate || new Date(8640000000000000);
            return aDate - bDate;
          })
          .map(({ _filterDate, _sortDate, ...rest }) => rest);

        setEvents(sortedEvents);
      } else {
        setEvents([]);
      }
    } catch (error) {
      console.error("Error fetching events:", error);
      setEvents([]);
    }
  };

  const fetchBannerData = async () => {
    try {
      const response = await fetch(`${baseurl}/banner/data/retrive`, {
        method: "POST",
        body: JSON.stringify({
          user_id: UserID,
          org_id: OrgID,
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${key}`,
        },
      });

      const data = await response.json();
      console.log("Banner API response:", data);

      if (data.status === true && data.data) {
        if (data.data.career_progress) {
          setCareerProgressData(data.data.career_progress);
        }
        if (data.data.banner_list && Array.isArray(data.data.banner_list)) {
          setBannerList(data.data.banner_list);
        }
        // Use skills, experience, and opportunities from profile_counts in API response
        if (data.data.profile_completion !== undefined) {
          setProfileCompleted(data.data.profile_completion);
          setProfileCompletedContext?.(data.data.profile_completion);
        }
        if (data.data.goals_completion !== undefined) {
          setGoalCompleted(data.data.goals_completion);
          setGoalCompletedContext?.(data.data.goals_completion);
        }
        if (data.data.profile_counts) {
          if (data.data.profile_counts.skills !== undefined) {
            setSkillCount(data.data.profile_counts.skills);
          }
          if (data.data.profile_counts.experience !== undefined) {
            setExperienceCount(data.data.profile_counts.experience);
          }
          if (data.data.profile_counts.opportunities !== undefined) {
            setOpportunitiesCount(data.data.profile_counts.opportunities);
          }
        }
        // Fallback to direct fields if profile_counts doesn't exist
        if (data.data.skills !== undefined && !data.data.profile_counts) {
          setSkillCount(data.data.skills);
        } else if (data.data.skill_count !== undefined && !data.data.profile_counts) {
          setSkillCount(data.data.skill_count);
        }
        if (data.data.experience !== undefined && !data.data.profile_counts) {
          setExperienceCount(data.data.experience);
        } else if (data.data.experience_count !== undefined && !data.data.profile_counts) {
          setExperienceCount(data.data.experience_count);
        }
        if (data.data.opportunities !== undefined && !data.data.profile_counts) {
          setOpportunitiesCount(data.data.opportunities);
        } else if (data.data.opportunities_count !== undefined && !data.data.profile_counts) {
          setOpportunitiesCount(data.data.opportunities_count);
        }
      }
    } catch (error) {
      console.error("Error fetching banner data:", error);
    }
  };

  // When goals are saved from the popup, softly "refresh the page":
  // show the overlay loader, then refetch banner, recommendations, and events.
  const handleGoalsSaved = async () => {
    if (!UserID) {
      return;
    }
    const previousPathSignature = JSON.stringify(
      (careerPathRef.current || []).map((step) => `${step?.step ?? ""}|${step?.title ?? ""}|${step?.description ?? ""}`)
    );
    setRefreshing(true);
    try {
      await Promise.all([fetchBannerData(), fetchCareerRecommendations(), fetchEvents()]);

      // Goal update can be eventually consistent on backend.
      // Retry recommendation fetch briefly so updated career path appears immediately.
      for (let attempt = 0; attempt < 3; attempt += 1) {
        const latestPathSignature = JSON.stringify(
          (careerPathRef.current || []).map((step) => `${step?.step ?? ""}|${step?.title ?? ""}|${step?.description ?? ""}`)
        );
        if (latestPathSignature !== previousPathSignature) break;
        await wait(700);
        await fetchCareerRecommendations();
      }
    } finally {
      setRefreshing(false);
    }
  };

  const fetchOpportunitiesCount = async () => {
    try {
      const memberId = localStorage.getItem('USERID');
      if (!memberId) {
        setOpportunitiesCount(0);
        return;
      }

      const response = await fetch(`${baseurl}/vacancies/list?member_id=${memberId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      const data = await response.json();
      if (data.status === 'success') {
        const total =
          typeof data.total === 'number' && !Number.isNaN(data.total)
            ? data.total
            : Array.isArray(data.data)
              ? data.data.length
              : 0;
        setOpportunitiesCount(total);
      } else {
        setOpportunitiesCount(0);
      }
    } catch (error) {
      console.error("Error fetching opportunities count:", error);
      setOpportunitiesCount(0);
    }
  };

  const fetchOffersCount = async () => {
    try {
      const token = JSON.parse(localStorage.getItem("access-token"));
      if (!token) {
        setOffersCount(0);
        setOffersReceivedCount(0);
        return;
      }

      const response = await fetch(`${baseurl}/offers/my-list`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });

      const data = await response.json();
      if (data.status === "success" && Array.isArray(data.data)) {
        setOffersCount(data.data.length);
        const acceptedCount = data.data.filter((o) => (o.status || "").toLowerCase().includes("accepted")).length;
        setOffersReceivedCount(acceptedCount);
      } else {
        setOffersCount(0);
        setOffersReceivedCount(0);
      }
    } catch (error) {
      console.error("Error fetching offers count:", error);
      setOffersCount(0);
      setOffersReceivedCount(0);
    }
  };

  const fetchCareerRecommendations = async () => {
    try {
      if (!UserID) {
        setSuggestions([]);
        setCareerScore(null);
        setCareerPath([]);
        setCareerPathLoading(false);
        return;
      }

      setCareerPathLoading(true);
      const response = await fetch(`${baseurl}/career/recommend`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ user_id: UserID }),
      });

      const data = await response.json();

      if (data.status === true) {
        const careerScoreVal = data.career_score ?? data.data?.career_score;
        if (careerScoreVal != null) {
          setCareerScore(typeof careerScoreVal === "number" ? careerScoreVal : parseInt(careerScoreVal, 10) || 0);
        }
        const path = data.career_path ?? data.data?.career_path ?? [];
        setCareerPath(Array.isArray(path) ? path : []);
        const recs = data.recommendations ?? data.data?.recommendations ?? [];
        if (recs.length > 0) {
        const formattedSuggestions = recs.map((item, index) => ({
          id: `rec-${index}-${item.title || ""}`,
          vacancyId: item.id || item.vacancy_id || null,
          learningId: item.learning_id || (item.category === "skill" ? item.id : null) || null,
          title: item.title || "",
          description: item.description || "",
          category: item.category || "",
          keywords: item.keywords || [],
          route: item.route || item.link || null,
        }));
        setSuggestions(formattedSuggestions);
        } else {
          setSuggestions([]);
        }
      } else {
        setSuggestions([]);
        setCareerScore(null);
        setCareerPath([]);
      }
    } catch (error) {
      console.error("Error fetching career recommendations:", error);
      setSuggestions([]);
      setCareerScore(null);
      setCareerPath([]);
    } finally {
      setCareerPathLoading(false);
    }
  };

  const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const careerPathSteps = Array.isArray(careerPath) ? careerPath : [];
  const hardcodedCareerPathSteps = [
    { step: 1, title: "Set your career goals", description: "Define your career objectives and target roles" },
    { step: 2, title: "Complete your profile", description: "Add your skills, experience, and qualifications" },
    { step: 3, title: "Explore learning paths", description: "Discover courses tailored to your goals" },
    { step: 4, title: "Track your progress", description: "Monitor your career readiness score" },
  ];
  const hardcodedRecommendations = [
    { id: "rec-1", vacancyId: null, title: "Complete your profile", description: "Add your skills and experience to get personalized recommendations", category: "profile", route: null },
    { id: "rec-2", vacancyId: null, title: "Set your career goals", description: "Define your objectives to discover relevant learning paths", category: "goals", route: null },
  ];
  const hardcodedEvents = [
    { event_id: "ev-1", event_title: "Career Workshop", event_type: "Webinar", event_description: "Learn how to advance your career", recommended_date: "Upcoming" },
    { event_id: "ev-2", event_title: "Skills Assessment", event_type: "Session", event_description: "Evaluate your current skill level", recommended_date: "This week" },
  ];
  const hasNoCareerData = !(
    careerProgressData.visitedLectures > 0 ||
    careerProgressData.completedItems > 0 ||
    (careerProgressData.totalScore != null && careerProgressData.totalScore > 0) ||
    (careerScore != null && careerScore > 0)
  );

  const isProfileGoalsIncomplete = (profileCompleted ?? 0) < 100 || (goalCompleted ?? 0) < 100;
  const profileIncomplete = (profileCompleted ?? 0) < 100;
  const goalIncomplete = (goalCompleted ?? 0) < 100;
  const getProfileGoalsOverlayMessage = () => {
    if (profileIncomplete && goalIncomplete) return "Update your profile and career goals for viewing career recommendations";
    if (profileIncomplete) return "Update your profile for viewing career recommendations";
    return "Update your career goals for viewing career recommendations";
  };

  const formatTime = (dateString) => {
    try {
      if (!dateString) return "";
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return "";
      const Timezone = localStorage.getItem("timezone");
      return date.toLocaleTimeString(undefined, {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
        timeZone: Timezone || "UTC",
      });
    } catch (error) {
      console.error("Error formatting time:", error);
      return "";
    }
  };

  const getPlainText = (htmlString) => {
    if (!htmlString) return "";
    const tmp = document.createElement("DIV");
    tmp.innerHTML = htmlString;
    return tmp.textContent || tmp.innerText || "";
  };

  useLayoutEffect(() => {
    const container = careerPathStepsRef.current;
    if (!container || careerPathLoading) return;

    const updateCareerPathLineHeight = () => {
      const lastStep = container.lastElementChild;
      const lastMarker = lastStep?.querySelector(`.${style.careerPathMarker}`);
      if (!lastMarker) return;

      const containerRect = container.getBoundingClientRect();
      const markerRect = lastMarker.getBoundingClientRect();
      const markerCenterY = markerRect.top - containerRect.top + markerRect.height / 2;

      // Keep line start and end consistent with CSS pseudo-element top value.
      const pseudoTop = parseFloat(window.getComputedStyle(container, "::before").top || "0");
      const topCompensation = Number.isFinite(pseudoTop) && pseudoTop < 0 ? Math.abs(pseudoTop) : 0;

      container.style.setProperty("--career-path-line-height", `${markerCenterY + topCompensation}px`);
    };

    updateCareerPathLineHeight();
    window.addEventListener("resize", updateCareerPathLineHeight);

    let resizeObserver;
    if (typeof ResizeObserver !== "undefined") {
      resizeObserver = new ResizeObserver(updateCareerPathLineHeight);
      resizeObserver.observe(container);
    }

    return () => {
      window.removeEventListener("resize", updateCareerPathLineHeight);
      if (resizeObserver) resizeObserver.disconnect();
    };
  }, [careerPathLoading, careerPathSteps, hasNoCareerData, isProfileGoalsIncomplete]);

  const fetchMentorDashboard = async () => {
    try {
      const res = await fetch(`${baseurl}/mentor/main/dashboard`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${key}`,
        },
        body: JSON.stringify({ user_id: UserID, org_id: OrgID }),
      });
      const data = await res.json();
      if (data.status === true && data.data?.[0]) {
        setMentorDashboardData(data.data[0]);
      }
    } catch (err) {
      console.error("Error fetching mentor dashboard:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (UserID) {
      if (showMentorDashboard) {
        fetchMentorDashboard();
        fetchBannerData();
        fetchReminders();
        fetchEvents();
      } else if (showPatnerDashboard) {
        fetchBannerData();
        fetchOffersCount();
        setCareerPathLoading(false);
        setLoading(false);
      } else {
        learningList();
        dailyWeeklyExam();
        fetchReminders();
        fetchEvents();
        fetchBannerData();
        fetchOffersCount();
        fetchCareerRecommendations();
      }
    } else {
      setCareerPathLoading(false);
      setLoading(false);
    }
  }, [UserID, showMentorDashboard, showPatnerDashboard]);

  // Refetch banner data when returning to dashboard from another route (e.g. after profile updates)
  const prevPathRef = useRef(location.pathname);
  useEffect(() => {
    if (location.pathname === "/" && prevPathRef.current !== "/" && UserID) {
      setRefreshing(true);
      const promises = showMentorDashboard
        ? [fetchBannerData(), fetchMentorDashboard(), fetchReminders(), fetchEvents()]
        : [fetchBannerData(), fetchCareerRecommendations(), fetchReminders(), fetchEvents()];
      Promise.all(promises).finally(() => setRefreshing(false));
    }
    prevPathRef.current = location.pathname;
  }, [location.pathname, UserID, showMentorDashboard]);

  useEffect(() => {
    // Reset welcome index when banner list changes
    const totalSlides = bannerList.length > 0 ? bannerList.length : 1;
    if (welcomeIndex >= totalSlides) {
      setWelcomeIndex(0);
    }
  }, [bannerList, welcomeIndex]);

  useEffect(() => {
    const totalSlides = bannerList.length > 0 ? bannerList.length : 1;
    if (totalSlides > 1) {
      const timer = setInterval(() => {
        setWelcomeIndex((prev) => (prev + 1) % totalSlides);
      }, 5000);

      return () => clearInterval(timer);
    }
  }, [bannerList]);

  const clearMobileCompletionCloseTimer = useCallback(() => {
    if (mobileCompletionCloseTimerRef.current != null) {
      clearTimeout(mobileCompletionCloseTimerRef.current);
      mobileCompletionCloseTimerRef.current = null;
    }
  }, []);

  const leaveCompletionTooltip = useCallback(() => {
    clearMobileCompletionCloseTimer();
    mobileCompletionCloseTimerRef.current = window.setTimeout(() => {
      setCompletionTooltipSource(null);
      setCompletionTooltipKind(null);
      setMobileCompletionCoords(null);
      mobileCompletionCloseTimerRef.current = null;
    }, 200);
  }, [clearMobileCompletionCloseTimer]);

  const enterCompletionTooltip = useCallback(
    (source, kind) => {
      clearMobileCompletionCloseTimer();
      setCompletionTooltipSource(source);
      setCompletionTooltipKind(kind);
    },
    [clearMobileCompletionCloseTimer],
  );

  const getCompletionAnchorEl = useCallback(() => {
    if (!completionTooltipSource || !completionTooltipKind) return null;
    if (completionTooltipSource === "mobile") {
      return completionTooltipKind === "profile" ? mobileProfileIconRef.current : mobileGoalsIconRef.current;
    }
    return completionTooltipKind === "profile" ? sidebarProfileIconRef.current : sidebarGoalsIconRef.current;
  }, [completionTooltipSource, completionTooltipKind]);

  const buildTooltipCoords = useCallback((anchorRect, preferredWidth = null) => {
    const margin = 12;
    const vw = window.innerWidth;
    const maxW = Math.min(280, vw - margin * 2);
    const width = Math.min(preferredWidth || maxW, maxW);
    const centerX = anchorRect.left + anchorRect.width / 2;
    const half = width / 2;
    const clampedCenter = Math.max(margin + half, Math.min(vw - margin - half, centerX));
    const panelLeft = clampedCenter - half;
    const arrowPadding = 18;
    const arrowLeft = Math.max(
      arrowPadding,
      Math.min(width - arrowPadding, centerX - panelLeft),
    );

    return {
      top: anchorRect.bottom + 10,
      left: clampedCenter,
      maxWidth: maxW,
      arrowLeft,
    };
  }, []);

  useLayoutEffect(() => {
    if (!completionTooltipSource || !completionTooltipKind) {
      setMobileCompletionCoords(null);
      return;
    }
    const el = getCompletionAnchorEl();
    if (!el) {
      return;
    }
    const rect = el.getBoundingClientRect();
    setMobileCompletionCoords(buildTooltipCoords(rect));

    let cancelled = false;
    const rafOuter = requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (cancelled) return;
        const panel = completionTooltipPanelRef.current;
        const anchor = getCompletionAnchorEl();
        if (!panel || !anchor) return;
        const r = anchor.getBoundingClientRect();
        const tw = panel.offsetWidth;
        const next = buildTooltipCoords(r, tw || undefined);
        setMobileCompletionCoords((prev) => {
          if (!prev) return prev;
          if (Math.abs(prev.left - next.left) < 0.5 && Math.abs(prev.arrowLeft - next.arrowLeft) < 0.5) {
            return prev;
          }
          return { ...prev, left: next.left, arrowLeft: next.arrowLeft, maxWidth: next.maxWidth };
        });
      });
    });
    return () => {
      cancelled = true;
      cancelAnimationFrame(rafOuter);
    };
  }, [completionTooltipSource, completionTooltipKind, profileCompleted, goalCompleted, getCompletionAnchorEl, buildTooltipCoords]);

  useEffect(() => {
    if (!completionTooltipSource || !completionTooltipKind) {
      return undefined;
    }
    const update = () => {
      const el = getCompletionAnchorEl();
      if (!el) return;
      const rect = el.getBoundingClientRect();
      setMobileCompletionCoords(buildTooltipCoords(rect));
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          const panel = completionTooltipPanelRef.current;
          const anchor = getCompletionAnchorEl();
          if (!panel || !anchor) return;
          const r = anchor.getBoundingClientRect();
          const tw = panel.offsetWidth;
          const next = buildTooltipCoords(r, tw || undefined);
          setMobileCompletionCoords((prev) =>
            prev ? { ...prev, left: next.left, arrowLeft: next.arrowLeft, maxWidth: next.maxWidth } : null,
          );
        });
      });
    };
    window.addEventListener("resize", update);
    window.addEventListener("scroll", update, true);
    return () => {
      window.removeEventListener("resize", update);
      window.removeEventListener("scroll", update, true);
    };
  }, [completionTooltipSource, completionTooltipKind, getCompletionAnchorEl, buildTooltipCoords]);

  useEffect(() => () => clearMobileCompletionCloseTimer(), [clearMobileCompletionCloseTimer]);

  useEffect(() => {
    // Cleanup previous chart instance
    if (chartInstance.current !== null) {
      chartInstance.current.destroy();
    }

    // Create new chart instance
    if (chartContainer.current) {
      chartInstance.current = new Chart(chartContainer.current, {
        type: "doughnut",
        data: {
          datasets: [
            {
              label: "Completion",
              data: [completionPercentage, 100 - completionPercentage],
              backgroundColor: ["#595BDB", "#FFF"],
            },
          ],
        },
        options: {
          responsive: true,
          cutout: "85%",
          plugins: {
            legend: {
              position: "top",
            },
            tooltip: {
              enabled: false,
            },
          },
        },
      });
    }

    // Cleanup function
    return () => {
      if (chartInstance.current !== null) {
        chartInstance.current.destroy();
      }
    };
  }, [completionPercentage]);

  useEffect(() => {
    const interval = setInterval(() => {
      dailyWeeklyExam();
    }, 60000);

    return () => clearInterval(interval);
  }, []);

  useLayoutEffect(() => {
    if (careerProgressChartInstance.current !== null) {
      careerProgressChartInstance.current.destroy();
      careerProgressChartInstance.current = null;
    }

    const scoreFromApi = careerScore != null ? careerScore : null;
    const hasNoCareerDataForChart = !(
      careerProgressData.visitedLectures > 0 ||
      careerProgressData.completedItems > 0 ||
      (careerProgressData.totalScore != null && careerProgressData.totalScore > 0) ||
      (careerScore != null && careerScore > 0)
    );
    const progress = hasNoCareerDataForChart
      ? 100
      : (scoreFromApi ?? careerProgressData.outerProgressPercentage ?? careerProgressData.innerProgressPercentage ?? 0);

    const minVisible = 2;
    const displayProgress = progress === 0 ? minVisible : Math.min(100, progress);

    // Smooth gradient: white→blue→orange→red→green (one continuous blend, no cuts)
    const lerp = (a, b, t) => {
      const ah = parseInt(a.slice(1), 16), ar = ah >> 16, ag = (ah >> 8) & 255, ab = ah & 255;
      const bh = parseInt(b.slice(1), 16), br = bh >> 16, bg = (bh >> 8) & 255, bb = bh & 255;
      const r = Math.round(ar + (br - ar) * t), g = Math.round(ag + (bg - ag) * t), b_ = Math.round(ab + (bb - ab) * t);
      return `#${((1 << 24) + (r << 16) + (g << 8) + b_).toString(16).slice(1)}`;
    };
    const stops = [
      [0, "#F5F9FF"], [0.2, "#2196F3"], [0.5, "#FF9800"], [0.75, "#E53935"], [1, "#4CAF50"]
    ];
    const getGradientColor = (t) => {
      for (let i = 0; i < stops.length - 1; i++) {
        if (t >= stops[i][0] && t <= stops[i + 1][0]) {
          const local = (t - stops[i][0]) / (stops[i + 1][0] - stops[i][0]);
          return lerp(stops[i][1], stops[i + 1][1], local);
        }
      }
      return stops[stops.length - 1][1];
    };

    const segments = 24;
    const segmentData = [];
    const segmentColors = [];
    const filled = displayProgress / 100;
    for (let i = 0; i < segments; i++) {
      const t0 = i / segments;
      const t1 = (i + 1) / segments;
      if (t1 <= filled) {
        segmentData.push(100 / segments);
        segmentColors.push(getGradientColor((t0 + t1) / 2));
      } else if (t0 < filled) {
        segmentData.push((filled - t0) * 100);
        segmentColors.push(getGradientColor((t0 + filled) / 2));
      }
    }
    segmentData.push(100 - displayProgress);
    segmentColors.push("transparent");

    if (careerProgressChartRef.current) {
      careerProgressChartInstance.current = new Chart(careerProgressChartRef.current, {
        type: "doughnut",
        data: {
          datasets: [
            {
              label: "Career Score",
              data: segmentData,
              backgroundColor: segmentColors,
              borderWidth: 0,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          cutout: "75%",
          layout: { padding: 0 },
          plugins: {
            legend: { display: false },
            tooltip: { enabled: false },
          },
        },
      });
    }

    return () => {
      if (careerProgressChartInstance.current !== null) {
        careerProgressChartInstance.current.destroy();
      }
    };
  }, [careerProgressData, careerScore]);

  useEffect(() => {
    const chart = careerProgressChartInstance.current;
    if (chart) {
      const t = setTimeout(() => chart.resize(), 200);
      return () => clearTimeout(t);
    }
  }, [careerProgressData, careerScore]);


  const mentorDefaultSlide = {
    title: "Welcome, Mentor",
    description: "",
    image: welcomeImage,
  };

  const mentorWelcomeSlides = bannerList.length > 0
    ? bannerList.map((banner) => ({
        title: banner.title || "",
        subtitle: banner.type || "",
        description: banner.description || "",
        image: banner.link || welcomeImage,
        link: banner.link || null,
        route: banner.route || banner.view_link || banner.redirect_to || null,
      }))
    : [mentorDefaultSlide];

  const mentorWelcomeIndex = bannerList.length > 0 ? welcomeIndex : 0;
  const mentorCurrentSlide = mentorWelcomeSlides[mentorWelcomeIndex] || mentorDefaultSlide;

  const MentorDashboardView = () => (
    <div className={style.dashboardWrapper}>
      <div className={`${style.dashboardSection} ${style.mentorDashboardSection}`}>
        <div className={style.greetingText}>
          <p className={style.greetingMain} title={greetingHeadline}>
            <span className={style.greetingPrefix}>Hi </span>
            <span className={style.greetingName}>{greetingName}</span>
            <span className={style.greetingSuffix}>, Good day</span>
          </p>
        </div>
        <div className={style.welcomeSection}>
          <div className={style.welcomeSectionLeft}>
            <p className={style.mentorWelcomeTitle}>{mentorCurrentSlide?.title || "Welcome, Mentor"}</p>
            {mentorCurrentSlide?.description && (
              <span className={style.mentorWelcomeDesc}>
                {mentorCurrentSlide?.description}
              </span>
            )}
            <div className={style.welcomeSectionImageMobile}>
              <div className={style.welcomeImageContainer}>
                <div className={style.welcomeImage}>
                  <img src={mentorCurrentSlide?.image || welcomeImage} alt="welcome" />
                </div>
              </div>
            </div>
            <div className={style.welcomeSectionBottom}>
              {bannerList.length > 0 && mentorCurrentSlide?.route && (
                <button
                  className={style.bannerViewButton}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleViewButtonClick(mentorCurrentSlide);
                  }}
                >
                  View
                  <FaArrowRightLong size={14} />
                </button>
              )}
              {mentorWelcomeSlides.length > 1 && (
                <div className={style.carouselDotsMobile}>
                  {mentorWelcomeSlides.map((_, index) => (
                    <button
                      key={index}
                      className={`${style.carouselDot} ${index === mentorWelcomeIndex ? style.carouselDotActive : ""}`}
                      onClick={(e) => {
                        e.stopPropagation();
                        setWelcomeIndex(index);
                      }}
                      aria-label={`Go to slide ${index + 1}`}
                    />
                  ))}
                </div>
              )}
            </div>
          </div>
          <div className={style.welcomeSectionRight}>
            <div className={style.welcomeImageContainer}>
              <div className={style.welcomeImage}>
                <img src={mentorCurrentSlide?.image || welcomeImage} alt="welcome" />
              </div>
            </div>
          </div>
        </div>
        <div className={style.squaresSection}>
          <div
            className={style.squareCard}
            onClick={() => navigate("/support")}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === "Enter" && navigate("/support")}
          >
            <div className={style.squareCardContent}>
              <p className={style.squareCardLabel}>Learners</p>
              <p className={style.squareCardNumber}>
                {mentorDashboardData?.Total_leaners_mapped ?? 0} <span className={style.squareCardSkillsText}>mapped</span>
              </p>
            </div>
          </div>
          <div
            className={style.squareCard}
            onClick={() => navigate("/calendar")}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === "Enter" && navigate("/calendar")}
          >
            <div className={style.squareCardContent}>
              <p className={style.squareCardLabel}>Sessions</p>
              <p className={style.squareCardNumber}>
                {mentorDashboardData?.sessions ?? 0} <span className={style.squareCardSkillsText}>scheduled</span>
              </p>
            </div>
          </div>
          <div
            className={style.squareCard}
            onClick={() => navigate("/support")}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === "Enter" && navigate("/support")}
          >
            <div className={style.squareCardContent}>
              <p className={style.squareCardLabel}>Support</p>
              <p className={style.squareCardNumber}>
                <span className={style.squareCardSkillsText}>View learners</span>
              </p>
            </div>
          </div>
          <div
            className={style.squareCard}
            onClick={() => navigate("/community")}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === "Enter" && navigate("/community")}
          >
            <div className={style.squareCardContent}>
              <p className={style.squareCardLabel}>Community</p>
              <p className={style.squareCardNumber}>
                <span className={style.squareCardSkillsText}>Connect</span>
              </p>
            </div>
          </div>
        </div>
        <div className={style.mentorQuickLinks}>
          <h3 className={style.mentorQuickLinksTitle}>Quick Actions</h3>
          <div className={style.mentorQuickLinksGrid}>
            <button className={style.mentorQuickLink} onClick={() => navigate("/support")}>
              <MdSupport className={style.mentorQuickLinkIcon} />
              <span>Support</span>
            </button>
            <button className={style.mentorQuickLink} onClick={() => navigate("/calendar")}>
              <MdOutlineEvent className={style.mentorQuickLinkIcon} />
              <span>Calendar</span>
            </button>
            <button className={style.mentorQuickLink} onClick={() => navigate("/learnings", { state: { source: "support" } })}>
              <LuBook className={style.mentorQuickLinkIcon} />
              <span>Learnings</span>
            </button>
            <button className={style.mentorQuickLink} onClick={() => navigate("/community")}>
              <LuUsers className={style.mentorQuickLinkIcon} />
              <span>Community</span>
            </button>
          </div>
        </div>
      </div>
      <div className={`${style.rightSidebar} ${style.mentorRightSidebar}`}>
        <div className={style.todosSection}>
          <h3 className={style.todosTitle}>To Dos</h3>
          <div className={style.todosContent}>
              {reminders.length > 0 ? (
                <>
                  {reminders.slice(0, 4).map((reminder) => (
                    <div
                      key={reminder.CalendarItemID}
                      className={style.todoCard}
                      onClick={() => navigate("/calendar")}
                      role="button"
                      tabIndex={0}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          navigate("/calendar");
                        }
                      }}
                    >
                      <div className={style.todoCardContent}>
                        <div className={style.todoTitle}>{reminder.Title}</div>
                        <div className={style.todoSubtitle}>
                          {reminder.Description ? getPlainText(reminder.Description) : reminder.ItemType || "Assignment"}
                        </div>
                      </div>
                      {reminder.StartDateTime?.$date && (
                        <button
                          type="button"
                          className={style.todoTime}
                          onClick={(e) => {
                            e.stopPropagation();
                            navigate("/calendar");
                          }}
                        >
                          {formatTime(reminder.StartDateTime.$date)}
                        </button>
                      )}
                    </div>
                  ))}
                  {reminders.length > 4 && (
                    <button className={style.viewAllButton} onClick={() => navigate("/calendar")}>
                      View All
                    </button>
                  )}
                </>
              ) : (
                <p className={style.emptyStateText}>No todos available</p>
              )}
          </div>
        </div>
        <div className={style.eventsSectionWrapper}>
          <h3 className={style.sidebarHeading}>Events</h3>
          <div className={style.eventsSection}>
            <div className={style.eventsContent}>
                {events.length > 0 ? (
                  <>
                    {events.slice(0, 2).map((event, index) => (
                      <div
                        key={`event-mentor-${index}-${event.event_id || event.event_title || ""}`}
                        className={style.eventCard}
                        onClick={() => {
                          if (event.event_id) {
                            localStorage.setItem("eventId", event.event_id);
                            localStorage.setItem("eventName", event.event_title || "Event");
                            navigate("/event/details");
                          } else {
                            navigate("/events");
                          }
                        }}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => {
                          if ((e.key === "Enter" || e.key === " ") && event.event_id) {
                            localStorage.setItem("eventId", event.event_id);
                            localStorage.setItem("eventName", event.event_title || "Event");
                            navigate("/event/details");
                          }
                        }}
                      >
                        <div className={style.eventTitle}>{event.event_title || "Event"}</div>
                        {event.event_type && <div className={style.eventHost}>{event.event_type}</div>}
                        {event.event_description && (
                          <div className={style.eventDescription}>{event.event_description}</div>
                        )}
                        {event.recommended_date && (
                          <div className={style.eventDateTime}>{event.recommended_date}</div>
                        )}
                      </div>
                    ))}
                    {events.length > 2 && (
                      <button
                        className={`${style.viewAllButton} ${style.viewAllButtonEvents}`}
                        onClick={(e) => {
                          e.stopPropagation();
                          navigate("/events");
                        }}
                      >
                        View All
                      </button>
                    )}
                  </>
                ) : (
                  <p className={style.emptyStateText}>No upcoming events</p>
                )}
            </div>
          </div>
        </div>
        <div className={style.notificationSection}>
          <h3 className={style.sidebarHeading}>Notifications</h3>
          <div className={style.notificationList}>
            {mentorNotifications.map((item, index) => (
              <div key={index} className={style.notificationCard}>
                <p className={style.notificationTitle}>{item.title}</p>
                <p className={style.notificationText}>{item.text}</p>
                <span className={style.notificationTime}>{item.time}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );

  const PatnerDashboardView = () => (
    <div className={style.dashboardWrapper}>
      <div className={style.dashboardSection}>
        <div className={style.greetingText}>
          <p className={style.greetingMain} title={greetingHeadline}>
            <span className={style.greetingPrefix}>Hi </span>
            <span className={style.greetingName}>{greetingName}</span>
            <span className={style.greetingSuffix}>, Good day</span>
          </p>
        </div>
        <div className={style.welcomeSection}>
          <div className={style.welcomeSectionLeft}>
            <p>{welcomeSlides[welcomeIndex]?.title || ""}</p>
            {welcomeSlides[welcomeIndex]?.description && (
              <span style={{ marginTop: "0.5rem", fontSize: "16px", color: "#666", lineHeight: "1.4", display: "block" }}>
                {welcomeSlides[welcomeIndex]?.description}
              </span>
            )}
            <div className={style.welcomeSectionImageMobile}>
              <div className={style.welcomeImageContainer}>
                <div className={style.welcomeImage}>
                  <img src={welcomeSlides[welcomeIndex]?.image || welcomeImage} alt="welcome" />
                </div>
              </div>
            </div>
            <div className={style.welcomeSectionBottom}>
              {bannerList.length > 0 && (
                <button
                  className={style.bannerViewButton}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleViewButtonClick(welcomeSlides[welcomeIndex]);
                  }}
                >
                  View
                  <FaArrowRightLong size={14} />
                </button>
              )}
              {welcomeSlides.length > 1 && (
                <div className={style.carouselDotsMobile}>
                  {welcomeSlides.map((_, index) => (
                    <button
                      key={index}
                      className={`${style.carouselDot} ${index === welcomeIndex ? style.carouselDotActive : ""}`}
                      onClick={(e) => {
                        e.stopPropagation();
                        setWelcomeIndex(index);
                      }}
                      aria-label={`Go to slide ${index + 1}`}
                    />
                  ))}
                </div>
              )}
            </div>
          </div>
          <div className={style.welcomeSectionRight}>
            <div className={style.welcomeImageContainer}>
              <div className={style.welcomeImage}>
                <img src={welcomeSlides[welcomeIndex]?.image || welcomeImage} alt="welcome" />
              </div>
            </div>
          </div>
        </div>
        <div className={style.squaresSection}>
          <div
            className={style.squareCard}
            onClick={() => navigate("/profile", { state: { activeTab: "Skills" } })}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === "Enter" && navigate("/profile", { state: { activeTab: "Skills" } })}
          >
            <div className={style.squareCardContent}>
              <p className={style.squareCardLabel}>Competency</p>
              <p className={style.squareCardNumber}>
                {skillCount} <span className={style.squareCardSkillsText}>skills</span>
              </p>
            </div>
          </div>
          <div
            className={style.squareCard}
            onClick={() => navigate("/profile", { state: { activeTab: "Experience" } })}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === "Enter" && navigate("/profile", { state: { activeTab: "Experience" } })}
          >
            <div className={style.squareCardContent}>
              <p className={style.squareCardLabel}>Experience</p>
              <p className={style.squareCardNumber}>
                {experienceCount} <span className={style.squareCardSkillsText}>years</span>
              </p>
            </div>
          </div>
          <div
            className={style.squareCard}
            onClick={() => navigate("/opportunities")}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === "Enter" && navigate("/opportunities")}
          >
            <div className={style.squareCardContent}>
              <p className={style.squareCardLabel}>Opportunities</p>
              <p className={style.squareCardNumber}>
                {opportunitiesCount} <span className={style.squareCardSkillsText}>applied</span>
              </p>
            </div>
          </div>
          <div
            className={style.squareCard}
            onClick={() => navigate("/offers")}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === "Enter" && navigate("/offers")}
          >
            <div className={style.squareCardContent}>
              <p className={style.squareCardLabel}>Offers</p>
              <p className={`${style.squareCardNumber} ${style.squareCardNumberOffers}`}>
                <span className={style.squareCardOfferLine}>
                  {offersCount}{" "}
                  <span className={style.squareCardSkillsText}>
                    offer{offersCount === 1 ? "" : "s"}
                  </span>
                </span>
                <span
                  className={`${style.squareCardOfferLine} ${style.squareCardOfferLineSecondary}`}
                >
                  {offersReceivedCount}{" "}
                  <span className={style.squareCardSkillsText}>received</span>
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className={style.rightSidebar}>
        <div className={style.remaindersSection}>
          <h3 className={style.recommendationHeading}>Recommendations</h3>
          <div className={style.suggestionSection}>
            {(suggestions.length > 0 ? suggestions : hardcodedRecommendations).map((suggestion) => (
              <div
                key={suggestion.id}
                className={style.suggestionCard}
                onClick={() => handleSuggestionClick(suggestion)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && handleSuggestionClick(suggestion)}
              >
                <div className={style.suggestionContent}>
                  <div className={style.suggestionTitle}>{suggestion.title}</div>
                  <div className={style.suggestionDescription}>{suggestion.description}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );

  const renderProfileGoalsCompletionCards = () => (
    <>
      <div className={style.profileGoalsCard}>
        <div className={style.profileGoalsCardTop}>
          <span className={style.profileGoalsCardTitle}>Profile Completion</span>
          <span className={style.profileGoalsCardPercent}>{profileCompleted}%</span>
        </div>
        <div className={style.profileGoalsCardBar}>
          <div
            className={style.profileGoalsCardBarFill}
            style={{
              width: `${profileCompleted}%`,
              background: "linear-gradient(90deg, #0151CD, #7C3AED)",
            }}
          />
        </div>
        <div className={style.profileGoalsCardBottom}>
          <span className={style.profileGoalsCardDesc}>Profile completed</span>
          <button
            type="button"
            className={style.profileGoalsCardBtn}
            onClick={() => {
              logActivity({ module: "DASHBOARD", action: "PROFILE_UPDATE_CLICK", remark: "Update profile from completion card" });
              navigate("/profile");
            }}
          >
            Update Profile
          </button>
        </div>
      </div>

      <div className={style.profileGoalsCard}>
        <div className={style.profileGoalsCardTop}>
          <span className={style.profileGoalsCardTitle}>Goals Completion</span>
          <span className={style.profileGoalsCardPercent}>{goalCompleted}%</span>
        </div>
        <div className={style.profileGoalsCardBar}>
          <div
            className={style.profileGoalsCardBarFill}
            style={{
              width: `${goalCompleted}%`,
              background: "linear-gradient(90deg, #0151CD, #7C3AED)",
            }}
          />
        </div>
        <div className={style.profileGoalsCardBottom}>
          <span className={style.profileGoalsCardDesc}>Career goals completed</span>
          <button
            type="button"
            className={style.profileGoalsCardBtn}
            onClick={() => {
              logActivity({ module: "DASHBOARD", action: "GOALS_UPDATE_CLICK", remark: "Update goals from completion card" });
              setShowGoalsPopup(true);
            }}
          >
            Update Career Goals
          </button>
        </div>
      </div>
    </>
  );

  return (
    <div className={style.container}>
      {typeof onMenuToggle === "function" && !sidebarOpen && (
        <button
          type="button"
          className={style.mobileMenuBtn}
          onClick={onMenuToggle}
          aria-label="Open menu"
        >
          <MdMoreVert size={24} />
        </button>
      )}
      {(loading || refreshing) && (
        <div className={style.loadingOverlay}>
          <Loader />
        </div>
      )}
      {showMentorDashboard ? (
        <MentorDashboardView />
      ) : showPatnerDashboard ? (
        <PatnerDashboardView />
      ) : (
      <div className={style.dashboardWrapper}>
        <div className={style.dashboardSection}>
          <div className={style.greetingText}>
            <p className={style.greetingMain} title={greetingHeadline}>
              <span className={style.greetingPrefix}>Hi </span>
              <span className={style.greetingName}>{greetingName}</span>
              <span className={style.greetingSuffix}>, Good day</span>
            </p>
              <div
                className={style.mobileCompletionIcons}
                onMouseLeave={leaveCompletionTooltip}
              >
                <div
                  ref={mobileProfileIconRef}
                  className={style.completionIconWrap}
                  title={`Profile: ${typeof profileCompleted === "number" ? profileCompleted : 0}%`}
                  onMouseEnter={() => enterCompletionTooltip("mobile", "profile")}
                >
                  <MdPerson
                    className={style.completionIcon}
                    style={{ color: profileCompleted === null ? "#7C3AED" : (profileCompleted >= 100 ? "#7C3AED" : "#1e3a8a") }}
                    size={24}
                  />
                </div>
                <div
                  ref={mobileGoalsIconRef}
                  className={style.completionIconWrap}
                  title={`Goals: ${typeof goalCompleted === "number" ? goalCompleted : 0}%`}
                  onMouseEnter={() => enterCompletionTooltip("mobile", "goals")}
                >
                  <MdFlag
                    className={style.completionIcon}
                    style={{ color: goalCompleted === null ? "#7C3AED" : (goalCompleted >= 100 ? "#7C3AED" : "#1e3a8a") }}
                    size={24}
                  />
                </div>
              </div>
          </div>
          <div className={style.welcomeSection}>

            {/* Desktop: left (title, desc, view+dots) | right (image). Mobile: image inside left column */}
            <div className={style.welcomeSectionLeft}>
              <p>{welcomeSlides[welcomeIndex]?.title || ''}</p>
              {welcomeSlides[welcomeIndex]?.description && (
                <span style={{ marginTop: '0.5rem', fontSize: '16px', color: '#666', lineHeight: '1.4', display: 'block' }}>
                  {welcomeSlides[welcomeIndex]?.description}
                </span>
              )}
              {/* Mobile: image inside banner, between desc and view+dots */}
              <div className={style.welcomeSectionImageMobile}>
                <div className={style.welcomeImageContainer}>
                  <div className={style.welcomeImage}>
                    <img
                      src={welcomeSlides[welcomeIndex]?.image || welcomeImage}
                      alt="welcome"
                    />
                  </div>
                </div>
              </div>
              <div className={style.welcomeSectionBottom}>
                {bannerList.length > 0 && (
                  <button
                    className={style.bannerViewButton}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleViewButtonClick(welcomeSlides[welcomeIndex]);
                    }}
                  >
                    View
                    <FaArrowRightLong size={14} />
                  </button>
                )}
                {welcomeSlides.length > 1 && (
                  <div className={style.carouselDotsMobile}>
                    {welcomeSlides.map((_, index) => (
                      <button
                        key={index}
                        className={`${style.carouselDot} ${index === welcomeIndex ? style.carouselDotActive : ''}`}
                        onClick={(e) => {
                          e.stopPropagation();
                          setWelcomeIndex(index);
                        }}
                        aria-label={`Go to slide ${index + 1}`}
                      />
                    ))}
                  </div>
                )}
              </div>
            </div>
            {/* Desktop only: image on right */}
            <div className={style.welcomeSectionRight}>
              <div className={style.welcomeImageContainer}>
                <div className={style.welcomeImage}>
                  <img
                    src={welcomeSlides[welcomeIndex]?.image || welcomeImage}
                    alt="welcome"
                  />
                </div>
              </div>
            </div>

          </div>
          <div className={style.squaresSection}>
            <div
              className={style.squareCard}
              onClick={() => navigate("/profile", { state: { activeTab: "Skills" } })}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === "Enter" && navigate("/profile", { state: { activeTab: "Skills" } })}
            >
              <div className={style.squareCardContent}>
                <p className={style.squareCardLabel}>Competency</p>
                <p className={style.squareCardNumber}>
                  {skillCount} <span className={style.squareCardSkillsText}>skills</span>
                </p>
              </div>
            </div>
            <div
              className={style.squareCard}
              onClick={() => navigate("/profile", { state: { activeTab: "Experience" } })}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === "Enter" && navigate("/profile", { state: { activeTab: "Experience" } })}
            >
              <div className={style.squareCardContent}>
                <p className={style.squareCardLabel}>Experience</p>
                <p className={style.squareCardNumber}>
                  {experienceCount} <span className={style.squareCardSkillsText}>years</span>
                </p>
              </div>
            </div>
            <div
              className={style.squareCard}
              onClick={() => navigate("/opportunities")}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === "Enter" && navigate("/opportunities")}
            >
              <div className={style.squareCardContent}>
                <p className={style.squareCardLabel}>Opportunities</p>
                <p className={style.squareCardNumber}>
                  {opportunitiesCount} <span className={style.squareCardSkillsText}>applied</span>
                </p>
              </div>
            </div>
            <div
              className={style.squareCard}
              onClick={() => navigate("/offers")}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === "Enter" && navigate("/offers")}
            >
              <div className={style.squareCardContent}>
                <p className={style.squareCardLabel}>Offers</p>
                <p className={`${style.squareCardNumber} ${style.squareCardNumberOffers}`}>
                  <span className={style.squareCardOfferLine}>
                    {offersCount}{" "}
                    <span className={style.squareCardSkillsText}>
                      offer{offersCount === 1 ? "" : "s"}
                    </span>
                  </span>
                  <span
                    className={`${style.squareCardOfferLine} ${style.squareCardOfferLineSecondary}`}
                  >
                    {offersReceivedCount}{" "}
                    <span className={style.squareCardSkillsText}>received</span>
                  </span>
                </p>
              </div>
            </div>
          </div>

          <div className={style.careerProgressCareerPathRow}>
            {/* Career Path - now in progress bar's position (left) */}
            <div className={style.careerPathSection}>
            <div
              className={`${style.careerPathTimeline} ${isProfileGoalsIncomplete ? style.careerPathTimelineLocked : ""}`}
              title={isProfileGoalsIncomplete ? "Update goals and profile" : undefined}
            >
              <div className={style.careerPathFlagAbove}>
                <CareerPathFlag />
                <h3 className={style.careerPathTitle}>Career Path</h3>
              </div>
              {careerPathLoading ? (
                <div className={style.careerPathEmpty}>
                  <p style={{ color: "#8C8C8C", fontSize: "14px", margin: 0 }}>
                    Loading your career path...
                  </p>
                </div>
              ) : (
                <div className={style.careerPathStepsWrapper}>
                  {isProfileGoalsIncomplete && (
                    <div className={style.careerPathLockOverlay}>
                      <div className={style.profileGoalsOverlayContent}>
                        <p className={style.profileGoalsOverlayMessage}>{getProfileGoalsOverlayMessage()}</p>
                        <div className={style.profileGoalsOverlayButtons}>
                          {profileIncomplete && (
                            <button className={style.profileGoalsOverlayBtn} onClick={(e) => { e.stopPropagation(); logActivity({ module: "DASHBOARD", action: "PROFILE_UPDATE_CLICK", remark: "Update profile from locked section" }); navigate("/profile"); }}>Update Profile</button>
                          )}
                          {goalIncomplete && (
                            <button className={style.profileGoalsOverlayBtn} onClick={(e) => { e.stopPropagation(); logActivity({ module: "DASHBOARD", action: "GOALS_UPDATE_CLICK", remark: "Update career goals from locked section" }); setShowGoalsPopup(true); }}>Update Career Goals</button>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                  <div ref={careerPathStepsRef} className={style.careerPathSteps}>
                    {(isProfileGoalsIncomplete ? hardcodedCareerPathSteps : (careerPathSteps.length > 0 ? careerPathSteps : [
                      { step: 1, title: "Step 1", description: "" },
                      { step: 2, title: "Step 2", description: "" },
                      { step: 3, title: "Step 3", description: "" },
                      { step: 4, title: "Step 4", description: "" }
                    ])).map((item, index) => {
                      const stepNum = item.step ?? index + 1;
                      const markerClasses = [style.careerPathMarker1, style.careerPathMarker2, style.careerPathMarker3, style.careerPathMarker4, style.careerPathMarker5];
                      const markerClass = markerClasses[Math.max(0, Math.min(stepNum - 1, 4))] ?? style.careerPathMarker5;
                      return (
                        <div key={`career-path-${index}-${item.title || stepNum}`} className={style.careerPathStep}>
                          <div className={`${style.careerPathMarker} ${markerClass}`}>{stepNum}</div>
                          <div className={`${style.careerPathCard} ${isProfileGoalsIncomplete ? style.careerPathCardBlur : ""}`}>
                            <p className={style.careerPathCardTitle}>{item.title || `Step ${stepNum}`}</p>
                            {item.description && (
                              <p className={style.careerPathCardDesc}>{item.description}</p>
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
          </div>

            <div className={style.careerProgressWrapper}>
              <div className={style.careerProgressSection}>
              <div className={style.careerProgressContent}>
                <div className={style.progressChartContainer}>
                  <h3 className={style.careerProgressTitle}>Career Score</h3>
                  <div className={style.progressChartWrapperOuter}>
                    {isProfileGoalsIncomplete && (
                      <div className={style.careerScoreLockOverlay}>
                        <div className={style.profileGoalsOverlayContent}>
                          <p className={style.profileGoalsOverlayMessage}>{getProfileGoalsOverlayMessage()}</p>
                          <div className={style.profileGoalsOverlayButtons}>
                            {profileIncomplete && (
                              <button className={style.profileGoalsOverlayBtn} onClick={(e) => { e.stopPropagation(); logActivity({ module: "DASHBOARD", action: "PROFILE_UPDATE_CLICK", remark: "Update profile from locked section" }); navigate("/profile"); }}>Update Profile</button>
                            )}
                            {goalIncomplete && (
                              <button className={style.profileGoalsOverlayBtn} onClick={(e) => { e.stopPropagation(); logActivity({ module: "DASHBOARD", action: "GOALS_UPDATE_CLICK", remark: "Update career goals from locked section" }); setShowGoalsPopup(true); }}>Update Career Goals</button>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                    <div
                      className={`${style.progressChartWrapper} ${isProfileGoalsIncomplete ? style.progressChartWrapperBlur : ""}`}
                    >
                      <canvas ref={careerProgressChartRef} className={style.progressChartOuter} width={300} height={300}></canvas>
                    <div className={style.progressChartCenter}>
                      {!isProfileGoalsIncomplete && (
                        <span className={style.progressChartNumber}>
                          {careerScore != null ? careerScore : careerProgressData.totalScore}
                        </span>
                      )}
                    </div>
                    </div>
                  </div>
                {!isProfileGoalsIncomplete && (
                  <div className={style.progressMetrics}>
                    <div className={style.progressMetric}>
                      <div className={style.progressMetricBar}></div>
                      <div className={style.progressMetricContent}>
                        <p className={style.progressMetricValue}>{(careerProgressData.totalItems || careerProgressData.totalLectures) || 25}</p>
                        <p className={style.progressMetricLabel}>Activities</p>
                      </div>
                    </div>
                    <div className={`${style.progressMetric} ${style.progressMetricEnd}`}>
                      <div className={style.progressMetricBar}></div>
                      <div className={style.progressMetricContent}>
                        <p className={style.progressMetricValue}>{careerProgressData.completedItems || 10}</p>
                        <p className={style.progressMetricLabel}>Completed</p>
                      </div>
                    </div>
                  </div>
                )}
                </div>
              </div>
            </div>
            </div>
            {profileCompleted !== null &&
              goalCompleted !== null &&
              profileCompleted >= 100 &&
              goalCompleted >= 100 && (
                <div
                  className={`${style.profileGoalsCards} ${style.profileGoalsCardsMobile} ${style.profileGoalsCardsCareerRow}`}
                >
                  {renderProfileGoalsCompletionCards()}
                </div>
              )}
          </div>

          {/* Mobile only: Recommendation, To Dos, Events below career score */}
          <div className={style.mobileRecommendationEventsTodos}>
            <div className={style.remaindersSection}>
              {((profileCompleted !== null && profileCompleted < 100) || (goalCompleted !== null && goalCompleted < 100)) && (
                <div className={style.completeSetupCard}>
                  <div className={style.completeSetupHeader}>
                    <MdWarning className={style.completeSetupIcon} />
                    <span>Complete Your Setup</span>
                  </div>
                  {goalCompleted !== null && goalCompleted < 100 && (
                    <div className={style.completeSetupSection}>
                      <div className={style.completeSetupSectionContent}>
                        <p className={style.completeSetupSectionTitle}>
                          Goals incomplete <span className={style.completeSetupPercent}>({goalCompleted}%)</span>
                        </p>
                        <p className={style.completeSetupSectionDesc}>Finish setting your career goals</p>
                      </div>
                      <button className={style.profileBannerButton} onClick={() => { logActivity({ module: "DASHBOARD", action: "GOALS_UPDATE_CLICK", remark: "Update goals from setup card" }); setShowGoalsPopup(true); }}>
                        Update
                      </button>
                    </div>
                  )}
                  {profileCompleted !== null && profileCompleted < 100 && (
                    <div className={style.completeSetupSection}>
                      <div className={style.completeSetupSectionContent}>
                        <p className={style.completeSetupSectionTitle}>
                          Profile incomplete <span className={style.completeSetupPercent}>({profileCompleted}%)</span>
                        </p>
                        <p className={style.completeSetupSectionDesc}>Complete your profile details</p>
                      </div>
                      <button className={style.profileBannerButton} onClick={() => { logActivity({ module: "DASHBOARD", action: "PROFILE_UPDATE_CLICK", remark: "Update profile from setup card" }); navigate("/profile"); }}>
                        Update
                      </button>
                    </div>
                  )}
                </div>
              )}
              <div className={style.recommendationHeadingBlock}>
                <h3 className={style.recommendationHeading}>Recommendations</h3>
                {profileCompleted !== null &&
                  goalCompleted !== null &&
                  (profileCompleted < 100 || goalCompleted < 100) && (
                    <div className={style.recommendationProfileActions}>
                      {profileCompleted < 100 && (
                        <button
                          type="button"
                          className={`${style.profileBannerButton} ${style.mobileProfileGoalBtn}`}
                          onClick={() => {
                            logActivity({
                              module: "DASHBOARD",
                              action: "PROFILE_UPDATE_CLICK",
                              remark: "Update profile below Recommendations heading",
                            });
                            navigate("/profile");
                          }}
                        >
                          Update Profile
                        </button>
                      )}
                      {goalCompleted < 100 && (
                        <button
                          type="button"
                          className={`${style.profileBannerButton} ${style.mobileProfileGoalBtn}`}
                          onClick={() => {
                            logActivity({
                              module: "DASHBOARD",
                              action: "GOALS_UPDATE_CLICK",
                              remark: "Update career goals below Recommendations heading",
                            });
                            setShowGoalsPopup(true);
                          }}
                        >
                          Update Career Goals
                        </button>
                      )}
                    </div>
                  )}
              </div>
              <div
                className={`${style.recommendationWrapper} ${isProfileGoalsIncomplete ? style.recommendationWrapperLocked : ""}`}
                title={isProfileGoalsIncomplete ? "Update goals and profile" : undefined}
              >
                {isProfileGoalsIncomplete && (
                  <div className={style.recommendationLockOverlay}>
                    <div className={style.profileGoalsOverlayContent}>
                      <p className={style.profileGoalsOverlayMessage}>{getProfileGoalsOverlayMessage()}</p>
                      <div className={style.profileGoalsOverlayButtons}>
                        {profileIncomplete && (
                          <button className={style.profileGoalsOverlayBtn} onClick={(e) => { e.stopPropagation(); logActivity({ module: "DASHBOARD", action: "PROFILE_UPDATE_CLICK", remark: "Update profile from locked section" }); navigate("/profile"); }}>Update Profile</button>
                        )}
                        {goalIncomplete && (
                          <button className={style.profileGoalsOverlayBtn} onClick={(e) => { e.stopPropagation(); logActivity({ module: "DASHBOARD", action: "GOALS_UPDATE_CLICK", remark: "Update career goals from locked section" }); setShowGoalsPopup(true); }}>Update Career Goals</button>
                        )}
                      </div>
                    </div>
                  </div>
                )}
                <div className={`${style.suggestionSection} ${isProfileGoalsIncomplete ? style.suggestionSectionBlur : ""}`}>
                  {(isProfileGoalsIncomplete ? hardcodedRecommendations : suggestions).length > 0 ? (
                    (isProfileGoalsIncomplete ? hardcodedRecommendations : suggestions).map((suggestion) => (
                      <div
                        key={suggestion.id}
                        className={style.suggestionCard}
                        onClick={() => handleSuggestionClick(suggestion)}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && handleSuggestionClick(suggestion)}
                      >
                        <div className={style.suggestionContent}>
                          <div className={style.suggestionTitle}>{suggestion.title}</div>
                          <div className={style.suggestionDescription}>{suggestion.description}</div>
                        </div>
                      </div>
                    ))
                  ) : null}
                </div>
              </div>
              {!hasNoCareerData && isProfileGoalsIncomplete && suggestions.length === 0 && (
                <div className={style.updateGoalsProfileHeadline}>
                  <p>{getProfileGoalsOverlayMessage()}</p>
                  <div className={style.updateGoalsProfileButtons}>
                    {profileIncomplete && (
                      <button className={style.profileBannerButton} onClick={() => { logActivity({ module: "DASHBOARD", action: "PROFILE_UPDATE_CLICK", remark: "Update profile from headline" }); navigate("/profile"); }}>Update Profile</button>
                    )}
                    {goalIncomplete && (
                      <button className={style.profileBannerButton} onClick={() => { logActivity({ module: "DASHBOARD", action: "GOALS_UPDATE_CLICK", remark: "Update career goals from headline" }); setShowGoalsPopup(true); }}>Update Career Goals</button>
                    )}
                  </div>
                </div>
              )}
            </div>
            <div className={style.todosSection}>
              <h3 className={style.todosTitle}>To Dos</h3>
              <div className={style.todosContent}>
                {reminders.length > 0 ? (
                  <>
                    {reminders.slice(0, 4).map((reminder) => (
                      <div
                        key={reminder.CalendarItemID}
                        className={style.todoCard}
                        onClick={() => navigate("/calendar")}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            navigate("/calendar");
                          }
                        }}
                      >
                        <div className={style.todoCardContent}>
                          <div className={style.todoTitle}>{reminder.Title}</div>
                          <div className={style.todoSubtitle}>
                            {reminder.Description
                              ? getPlainText(reminder.Description)
                              : reminder.ItemType || "Assignment"}
                          </div>
                        </div>
                        {reminder.StartDateTime?.$date && (
                          <button
                            type="button"
                            className={style.todoTime}
                            onClick={(e) => {
                              e.stopPropagation();
                              navigate("/calendar");
                            }}
                          >
                            {formatTime(reminder.StartDateTime.$date)}
                          </button>
                        )}
                      </div>
                    ))}
                    {reminders.length > 4 && (
                      <button
                        className={style.viewAllButton}
                        onClick={() => navigate("/calendar")}
                      >
                        View All
                      </button>
                    )}
                  </>
                ) : (
                  <p className={style.emptyStateText}>No todos available</p>
                )}
              </div>
            </div>
            <div
              className={`${style.eventsSectionWrapper} ${isProfileGoalsIncomplete ? style.eventsSectionWrapperLocked : ""}`}
              title={isProfileGoalsIncomplete ? "Update goals and profile" : undefined}
            >
              <h3 className={style.sidebarHeading}>Events</h3>
              <div className={style.eventsSection}>
                {isProfileGoalsIncomplete && (
                  <div className={style.eventsLockOverlay}>
                    <div className={style.profileGoalsOverlayContent}>
                      <p className={style.profileGoalsOverlayMessage}>{getProfileGoalsOverlayMessage()}</p>
                      <div className={style.profileGoalsOverlayButtons}>
                        {profileIncomplete && (
                          <button className={style.profileGoalsOverlayBtn} onClick={(e) => { e.stopPropagation(); logActivity({ module: "DASHBOARD", action: "PROFILE_UPDATE_CLICK", remark: "Update profile from locked section" }); navigate("/profile"); }}>Update Profile</button>
                        )}
                        {goalIncomplete && (
                          <button className={style.profileGoalsOverlayBtn} onClick={(e) => { e.stopPropagation(); logActivity({ module: "DASHBOARD", action: "GOALS_UPDATE_CLICK", remark: "Update career goals from locked section" }); setShowGoalsPopup(true); }}>Update Career Goals</button>
                        )}
                      </div>
                    </div>
                  </div>
                )}
                <div className={`${style.eventsContent} ${isProfileGoalsIncomplete ? style.eventsContentBlur : ""}`}>
                  {(isProfileGoalsIncomplete ? hardcodedEvents : events).length > 0 ? (
                    <>
                      {(isProfileGoalsIncomplete ? hardcodedEvents : events).slice(0, 2).map((event, index) => (
                        <div
                          key={`event-mobile-${index}-${event.event_id || event.event_title || ""}`}
                          className={style.eventCard}
                          onClick={() => {
                            if (!isProfileGoalsIncomplete && event.event_id) {
                              localStorage.setItem("eventId", event.event_id);
                              localStorage.setItem("eventName", event.event_title || "Event");
                              navigate("/event/details");
                            } else if (!isProfileGoalsIncomplete) {
                              navigate("/events");
                            }
                          }}
                          role="button"
                          tabIndex={0}
                          onKeyDown={(e) => {
                            if (!isProfileGoalsIncomplete && (e.key === "Enter" || e.key === " ") && event.event_id) {
                              localStorage.setItem("eventId", event.event_id);
                              localStorage.setItem("eventName", event.event_title || "Event");
                              navigate("/event/details");
                            }
                          }}
                        >
                          <div className={style.eventTitle}>{event.event_title || "Event"}</div>
                          {event.event_type && (
                            <div className={style.eventHost}>{event.event_type}</div>
                          )}
                          {event.event_description && (
                            <div className={style.eventDescription}>{event.event_description}</div>
                          )}
                          {event.recommended_date && (
                            <div className={style.eventDateTime}>
                              {event.recommended_date}
                            </div>
                          )}
                        </div>
                      ))}
                      {!isProfileGoalsIncomplete && events.length > 2 && (
                        <button
                          className={`${style.viewAllButton} ${style.viewAllButtonEvents}`}
                          onClick={(e) => {
                            e.stopPropagation();
                            navigate("/events");
                          }}
                        >
                          View All
                        </button>
                      )}
                    </>
                  ) : (
                    <p className={style.emptyStateText}>No upcoming events</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={style.rightSidebar}>
          {/* <div className={style.rightSidebarHeader}>
            <div className={style.rightSidebarHeaderLeft}>
              <div className={style.notificationIconImage}>
                <img src={NotificationICon} alt="notification" />
              </div>
            </div>
            <div className={style.userIcon}>
              <img src={Profile} alt="user" />
            </div>
          </div>
          <div className={style.rightSidebarDivider}></div> */}
          <div className={style.rightSidebarIcons} onMouseLeave={leaveCompletionTooltip}>
            <div
              ref={sidebarProfileIconRef}
              className={style.completionIconWrap}
              title={`Profile: ${typeof profileCompleted === "number" ? profileCompleted : 0}%`}
              onMouseEnter={() => enterCompletionTooltip("sidebar", "profile")}
            >
              <MdPerson
                className={style.completionIcon}
                style={{ color: profileCompleted === null ? "#7C3AED" : (profileCompleted >= 100 ? "#7C3AED" : "#1e3a8a") }}
                size={24}
              />
            </div>
            <div
              ref={sidebarGoalsIconRef}
              className={style.completionIconWrap}
              title={`Goals: ${typeof goalCompleted === "number" ? goalCompleted : 0}%`}
              onMouseEnter={() => enterCompletionTooltip("sidebar", "goals")}
            >
              <MdFlag
                className={style.completionIcon}
                style={{ color: goalCompleted === null ? "#7C3AED" : (goalCompleted >= 100 ? "#7C3AED" : "#1e3a8a") }}
                size={24}
              />
            </div>
          </div>
          <div className={style.remaindersSection}>
            {((profileCompleted !== null && profileCompleted < 100) || (goalCompleted !== null && goalCompleted < 100)) && (
              <div className={style.completeSetupCard}>
                <div className={style.completeSetupHeader}>
                  <MdWarning className={style.completeSetupIcon} />
                  <span>Complete Your Setup</span>
                </div>
                {goalCompleted !== null && goalCompleted < 100 && (
                  <div className={style.completeSetupSection}>
                    <div className={style.completeSetupSectionContent}>
                      <p className={style.completeSetupSectionTitle}>
                        Goals incomplete <span className={style.completeSetupPercent}>({goalCompleted}%)</span>
                      </p>
                      <p className={style.completeSetupSectionDesc}>Finish setting your career goals</p>
                    </div>
                    <button
                      className={style.profileBannerButton}
                      onClick={() => {
                        logActivity({ module: "DASHBOARD", action: "GOALS_UPDATE_CLICK", remark: "Update goals from setup card" });
                        setShowGoalsPopup(true);
                      }}
                    >
                      Update
                    </button>
                  </div>
                )}
                {profileCompleted !== null && profileCompleted < 100 && (
                  <div className={style.completeSetupSection}>
                    <div className={style.completeSetupSectionContent}>
                      <p className={style.completeSetupSectionTitle}>
                        Profile incomplete <span className={style.completeSetupPercent}>({profileCompleted}%)</span>
                      </p>
                      <p className={style.completeSetupSectionDesc}>Complete your profile details</p>
                    </div>
                    <button
                      className={style.profileBannerButton}
                      onClick={() => {
                        logActivity({ module: "DASHBOARD", action: "PROFILE_UPDATE_CLICK", remark: "Update profile from setup card" });
                        navigate("/profile");
                      }}
                    >
                      Update
                    </button>
                  </div>
                )}
              </div>
            )}
            {profileCompleted !== null &&
              goalCompleted !== null &&
              profileCompleted >= 100 &&
              goalCompleted >= 100 && (
                <div className={style.profileGoalsCards}>
                  {renderProfileGoalsCompletionCards()}
                </div>
              )}
            <h3 className={style.recommendationHeading}>Recommendations</h3>
            <div
              className={`${style.recommendationWrapper} ${isProfileGoalsIncomplete ? style.recommendationWrapperLocked : ""}`}
              title={isProfileGoalsIncomplete ? "Update goals and profile" : undefined}
            >
              {isProfileGoalsIncomplete && (
                <div className={style.recommendationLockOverlay}>
                  <div className={style.profileGoalsOverlayContent}>
                    <p className={style.profileGoalsOverlayMessage}>{getProfileGoalsOverlayMessage()}</p>
                    <div className={style.profileGoalsOverlayButtons}>
                      {profileIncomplete && (
                        <button className={style.profileGoalsOverlayBtn} onClick={(e) => { e.stopPropagation(); logActivity({ module: "DASHBOARD", action: "PROFILE_UPDATE_CLICK", remark: "Update profile from locked section" }); navigate("/profile"); }}>Update Profile</button>
                      )}
                      {goalIncomplete && (
                        <button className={style.profileGoalsOverlayBtn} onClick={(e) => { e.stopPropagation(); logActivity({ module: "DASHBOARD", action: "GOALS_UPDATE_CLICK", remark: "Update career goals from locked section" }); setShowGoalsPopup(true); }}>Update Career Goals</button>
                      )}
                    </div>
                  </div>
                </div>
              )}
              <div className={`${style.suggestionSection} ${isProfileGoalsIncomplete ? style.suggestionSectionBlur : ""}`}>
                {(isProfileGoalsIncomplete ? hardcodedRecommendations : suggestions).length > 0 ? (
                  (isProfileGoalsIncomplete ? hardcodedRecommendations : suggestions).map((suggestion) => (
                    <div
                      key={suggestion.id}
                      className={style.suggestionCard}
                      onClick={() => handleSuggestionClick(suggestion)}
                      role="button"
                      tabIndex={0}
                      onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && handleSuggestionClick(suggestion)}
                    >
                      <div className={style.suggestionContent}>
                        <div className={style.suggestionTitle}>{suggestion.title}</div>
                        <div className={style.suggestionDescription}>{suggestion.description}</div>
                      </div>
                    </div>
                  ))
                ) : null}
              </div>
            </div>
            {!hasNoCareerData && isProfileGoalsIncomplete && suggestions.length === 0 && (
              <div className={style.updateGoalsProfileHeadline}>
                <p>{getProfileGoalsOverlayMessage()}</p>
                <div className={style.updateGoalsProfileButtons}>
                  {profileIncomplete && (
                    <button className={style.profileBannerButton} onClick={() => { logActivity({ module: "DASHBOARD", action: "PROFILE_UPDATE_CLICK", remark: "Update profile from headline" }); navigate("/profile"); }}>Update Profile</button>
                  )}
                  {goalIncomplete && (
                    <button className={style.profileBannerButton} onClick={() => { logActivity({ module: "DASHBOARD", action: "GOALS_UPDATE_CLICK", remark: "Update career goals from headline" }); setShowGoalsPopup(true); }}>Update Career Goals</button>
                  )}
                </div>
              </div>
            )}
          </div>
          <div className={style.todosSection}>
            <h3 className={style.todosTitle}>To Dos</h3>
            <div className={style.todosContent}>
              {reminders.length > 0 ? (
                <>
                  {reminders.slice(0, 4).map((reminder) => (
                    <div
                      key={reminder.CalendarItemID}
                      className={style.todoCard}
                      onClick={() => navigate("/calendar")}
                      role="button"
                      tabIndex={0}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          navigate("/calendar");
                        }
                      }}
                    >
                      <div className={style.todoCardContent}>
                        <div className={style.todoTitle}>{reminder.Title}</div>
                        <div className={style.todoSubtitle}>
                          {reminder.Description
                            ? getPlainText(reminder.Description)
                            : reminder.ItemType || "Assignment"}
                        </div>
                      </div>
                      {reminder.StartDateTime?.$date && (
                        <button
                          type="button"
                          className={style.todoTime}
                          onClick={(e) => {
                            e.stopPropagation();
                            navigate("/calendar");
                          }}
                        >
                          {formatTime(reminder.StartDateTime.$date)}
                        </button>
                      )}
                    </div>
                  ))}
                  {reminders.length > 4 && (
                    <button
                      className={style.viewAllButton}
                      onClick={() => navigate("/calendar")}
                    >
                      View All
                    </button>
                  )}
                </>
              ) : (
                <p className={style.emptyStateText}>No todos available</p>
              )}
            </div>
          </div>
          <div
            className={`${style.eventsSectionWrapper} ${isProfileGoalsIncomplete ? style.eventsSectionWrapperLocked : ""}`}
            title={isProfileGoalsIncomplete ? "Update goals and profile" : undefined}
          >
            <h3 className={style.sidebarHeading}>Events</h3>
            <div className={style.eventsSection}>
              {isProfileGoalsIncomplete && (
                <div className={style.eventsLockOverlay}>
                  <div className={style.profileGoalsOverlayContent}>
                    <p className={style.profileGoalsOverlayMessage}>{getProfileGoalsOverlayMessage()}</p>
                    <div className={style.profileGoalsOverlayButtons}>
                      {profileIncomplete && (
                        <button className={style.profileGoalsOverlayBtn} onClick={(e) => { e.stopPropagation(); logActivity({ module: "DASHBOARD", action: "PROFILE_UPDATE_CLICK", remark: "Update profile from locked section" }); navigate("/profile"); }}>Update Profile</button>
                      )}
                      {goalIncomplete && (
                        <button className={style.profileGoalsOverlayBtn} onClick={(e) => { e.stopPropagation(); logActivity({ module: "DASHBOARD", action: "GOALS_UPDATE_CLICK", remark: "Update career goals from locked section" }); setShowGoalsPopup(true); }}>Update Career Goals</button>
                      )}
                    </div>
                  </div>
                </div>
              )}
              <div className={`${style.eventsContent} ${isProfileGoalsIncomplete ? style.eventsContentBlur : ""}`}>
                {(isProfileGoalsIncomplete ? hardcodedEvents : events).length > 0 ? (
                  <>
                    {(isProfileGoalsIncomplete ? hardcodedEvents : events).slice(0, 2).map((event, index) => (
                      <div
                        key={`event-${index}-${event.event_id || event.event_title || ""}`}
                        className={style.eventCard}
                        onClick={() => {
                          if (!isProfileGoalsIncomplete && event.event_id) {
                            localStorage.setItem("eventId", event.event_id);
                            localStorage.setItem("eventName", event.event_title || "Event");
                            navigate("/event/details");
                          } else if (!isProfileGoalsIncomplete) {
                            navigate("/events");
                          }
                        }}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => {
                          if (!isProfileGoalsIncomplete && (e.key === "Enter" || e.key === " ") && event.event_id) {
                            localStorage.setItem("eventId", event.event_id);
                            localStorage.setItem("eventName", event.event_title || "Event");
                            navigate("/event/details");
                          }
                        }}
                      >
                        <div className={style.eventTitle}>{event.event_title || "Event"}</div>
                        {event.event_type && (
                          <div className={style.eventHost}>{event.event_type}</div>
                        )}
                        {event.event_description && (
                          <div className={style.eventDescription}>{event.event_description}</div>
                        )}
                        {event.recommended_date && (
                          <div className={style.eventDateTime}>
                            {event.recommended_date}
                          </div>
                        )}
                      </div>
                    ))}
                    {!isProfileGoalsIncomplete && events.length > 2 && (
                      <button
                        className={`${style.viewAllButton} ${style.viewAllButtonEvents}`}
                        onClick={(e) => {
                          e.stopPropagation();
                          navigate("/events");
                        }}
                      >
                        View All
                      </button>
                    )}
                  </>
                ) : (
                  <p className={style.emptyStateText}>No upcoming events</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      )}
      {dailYDrill ? (
        <>
          <div className={style.popupOverlay} onClick={() => {
            setDailyDrill(false)
          }}></div>
          <div className={style.Popup}>
            <div className={style.popupHeader}>
              <div className={style.popupHeaderIcon}>
                <img src={ActiveCalendar} alt="calendar" />
              </div>
              <div className={style.popupMainHeader}>
                <p>Daily Drill</p>
              </div>
              <div className={style.popupSubHeader}>
                <p>
                  Sharpen your skills daily with quick, focused exercises.
                  <br />
                  Practice makes perfect!
                </p>
              </div>
            </div>
            <div className={style.popupBody}>
              <div className={style.popupBodyTop}>
                <div className={style.popupBodyCard}>
                  <span>{result?.Daily_Drill?.no_of_questions}</span><p>Questions</p>
                </div>
                <div className={style.popupBodyCard}>
                  <img src={TimerImage} alt="timer" /><p>{result?.Daily_Drill?.alloted_time} mins</p>
                </div>
              </div>
              <div className={style.popupBodyBottom}>
                <p>Are you ready to take the daily drill?</p>
              </div>
            </div>
            <div className={style.PopupButton}>
              <button className={style.snoozeButton} onClick={() => {
                setDailyDrill(false);
                setActivePopup('dailyDrill');
                setSnoozePopup(true);
              }}>
                Snooze
              </button>
              <button className={style.yesButton} onClick={() => {
                navigate("/daily/drill")
              }}>
                Yes
              </button>
            </div>
          </div>
        </>
      ) : (
        ""
      )}
      {weeklyWorkout ? (
        <>
          <div className={style.popupOverlay} onClick={() => {
            setWeeklyWorkout(false)
          }}></div>
          <div className={style.Popup}>
            <div className={style.popupHeader}>
              <div className={style.popupHeaderIcon}>
                <img src={ActiveWorkOut} alt="calendar" />
              </div>
              <div className={style.popupMainHeader}>
                <p>Weekly Workout</p>
              </div>
              <div className={style.popupSubHeader}>
                <p>
                  Sharpen your skills daily with quick, focused exercises.
                  <br />
                  Practice makes perfect!
                </p>
              </div>
            </div>
            <div className={style.popupBody}>
              <div className={style.popupBodyTop}>
                <div className={style.popupBodyCard}>
                  <span>{result?.WeeklyDrill?.no_of_questions}</span><p>Questions</p>
                </div>
                <div className={style.popupBodyCard}>
                  <img src={TimerImage} alt="timer" /><p>{result?.WeeklyDrill?.alloted_time} mins</p>
                </div>
              </div>
              <div className={style.popupBodyBottom}>
                <p>Are you ready to take the weekly workout?</p>
              </div>
            </div>
            <div className={style.PopupButton}>
              <button className={style.snoozeButton} onClick={() => {
                setWeeklyWorkout(false);
                setActivePopup('weeklyWorkout');
                setSnoozePopup(true);
              }}>
                Snooze
              </button>
              <button style={{ background: "#00DFC7" }} className={style.yesButton} onClick={() => {
                navigate("/weekly/workout");
                window.location.reload();
              }}>
                Yes
              </button>
            </div>
          </div>
        </>
      ) : (
        ""
      )}
      {snoozePopup ? (
        <>
          <div className={style.popupOverlay} onClick={() => {
            setSnoozePopup(false)
            setActivePopup(null)
          }}></div>
          <div className={style.Popup}>
            <div className={style.snoozeHeader}>
              <p>When should we remind you for the {activePopup === 'dailyDrill' ? 'Daily Drill' : 'Weekly Workout'}?</p>
            </div>
            <div className={style.snoozeContainer}>
              <div onClick={() => handleSnooze(5)} className={style.snoozeCard}>
                <p>In 5 min</p>
              </div>
              <div onClick={() => handleSnooze(10)} className={style.snoozeCard}>
                <p>In 10 min</p>
              </div>
              <div onClick={() => handleSnooze(15)} className={style.snoozeCard}>
                <p>In 15 min</p>
              </div>
            </div>
          </div>
        </>
      ) : (
        ""
      )}
      {videoPopup && (
        <>
          <div className={style.popupOverlay}></div>
          <div className={style.videoPopup}>
            <div className={style.videoContainer}>
              <div className={style.videoClose}>
                <AiOutlineClose onClick={() => setVideoPopup(false)} />
              </div>
              <video controls>
                <source src="https://firebasestorage.googleapis.com/v0/b/oculusinstaller.appspot.com/o/demo.mp4?alt=media&token=aa5f2941-28d1-4681-868f-a5b173b1d892" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        </>
      )}

      <GoalsPopup
        open={showGoalsPopup}
        onClose={() => setShowGoalsPopup(false)}
        theme="dashboard"
        onSuccess={handleGoalsSaved}
      />

      {typeof document !== "undefined" &&
        completionTooltipSource &&
        completionTooltipKind &&
        mobileCompletionCoords &&
        createPortal(
          <div
            ref={completionTooltipPanelRef}
            role="tooltip"
            className={`${style.completionTooltip} ${style.completionTooltipPortal} ${
              completionTooltipKind === "profile"
                ? (profileCompleted ?? 0) < 100
                  ? style.completionTooltipPartial
                  : style.completionTooltipSuccess
                : (goalCompleted ?? 0) === 0
                  ? style.completionTooltipProgress
                  : (goalCompleted ?? 0) < 100
                    ? style.completionTooltipPartial
                    : style.completionTooltipSuccess
            }`}
            style={{
              top: mobileCompletionCoords.top,
              left: mobileCompletionCoords.left,
              maxWidth: mobileCompletionCoords.maxWidth,
              "--completion-arrow-left": `${mobileCompletionCoords.arrowLeft ?? 24}px`,
            }}
            onMouseEnter={clearMobileCompletionCloseTimer}
            onMouseLeave={leaveCompletionTooltip}
          >
            {completionTooltipKind === "profile" ? (
              <>
                <div className={style.completionTooltipHeader}>
                  <span className={style.completionTooltipLabel}>Profile</span>
                  {(profileCompleted ?? 0) < 100 ? (
                    <MdWarning className={style.completionTooltipIcon} style={{ color: "#93c5fd" }} />
                  ) : (
                    <AiFillCheckCircle className={style.completionTooltipIcon} style={{ color: "#7C3AED" }} />
                  )}
                </div>
                <div className={style.completionTooltipBar}>
                  <div
                    className={style.completionTooltipBarFill}
                    style={{
                      width: `${profileCompleted ?? 0}%`,
                      background:
                        (profileCompleted ?? 0) >= 100
                          ? "linear-gradient(90deg, #0151CD, #7C3AED)"
                          : "linear-gradient(90deg, #1e3a8a, #93c5fd)",
                    }}
                  />
                </div>
                <div
                  className={`${style.completionTooltipStatus} ${
                    (profileCompleted ?? 0) < 100
                      ? style.completionTooltipStatusPartial
                      : style.completionTooltipStatusSuccess
                  }`}
                >
                  <span className={style.completionTooltipPercent}>{profileCompleted ?? 0}%</span>
                  <span className={style.completionTooltipText}>
                    {(profileCompleted ?? 0) < 100 ? "Incomplete" : "Complete"}
                  </span>
                </div>
              </>
            ) : (
              <>
                <div className={style.completionTooltipHeader}>
                  <span className={style.completionTooltipLabel}>Goals</span>
                  {(goalCompleted ?? 0) >= 100 ? (
                    <AiFillCheckCircle className={style.completionTooltipIcon} style={{ color: "#7C3AED" }} />
                  ) : (
                    <MdWarning className={style.completionTooltipIcon} style={{ color: "#93c5fd" }} />
                  )}
                </div>
                <div className={style.completionTooltipBar}>
                  <div
                    className={style.completionTooltipBarFill}
                    style={{
                      width: `${goalCompleted ?? 0}%`,
                      background:
                        (goalCompleted ?? 0) >= 100
                          ? "linear-gradient(90deg, #0151CD, #7C3AED)"
                          : "linear-gradient(90deg, #1e3a8a, #93c5fd)",
                    }}
                  />
                </div>
                <div
                  className={`${style.completionTooltipStatus} ${
                    (goalCompleted ?? 0) === 0
                      ? style.completionTooltipStatusProgress
                      : (goalCompleted ?? 0) < 100
                        ? style.completionTooltipStatusPartial
                        : style.completionTooltipStatusSuccess
                  }`}
                >
                  <span className={style.completionTooltipPercent}>{goalCompleted ?? 0}%</span>
                  <span className={style.completionTooltipText}>
                    {(goalCompleted ?? 0) < 100 ? "Incomplete" : "Complete"}
                  </span>
                </div>
              </>
            )}
          </div>,
          document.body,
        )}

    </div>
  );
};

export default Dashboard;
